
// export const BASE_URL = "http://localhost:5000/api";
// export const SOCKET_URL = "http://localhost:8080"



// x
export const BASE_URL = "https://www.acecam.tech:5000/api"
export const SOCKET_URL = "https://www.acecam.tech:8080"